export default "__VITE_PUBLIC_ASSET__1e1d5ae3__"